import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'absPipe'
})
export class AbsPipe implements PipeTransform {

  transform(value: number): number {
    return Math.abs(value);
  }

}
